<template>
<div>
    <v-row>
        <v-col>
            <v-card color="#262F56" elevation="6">
                <v-row>
                    <v-col cols="7">
                        <div style="line-height: 110%;" class="headline page-header white--text text--bold text-left pl-6 pt-2" >
                            {{$t('credit_score.header')}}
                        </div>
                    </v-col>
                    <v-col style="height: 120px;" cols="5" class="pa-0">
                        <div style="margin-left: -40px">
                          <CreditScoreChart :score="user.credit_score"></CreditScoreChart>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="!user.credit_score">
                    <v-col>
                        <v-btn class="w95" @click="creditScoreQuestions()">
                            <div class="green--text">
                                {{$t('credit_score.find_out_rating')}}
                            </div>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>

    <v-row v-if="!user.credit_score">
        <v-col>
            <InfoBox :text="$t('credit_score.know_you_rating_for_offers')" :icon="icon"></InfoBox>
        </v-col>
    </v-row>
    <v-row v-else>
        <v-col>
            <InfoBox :text="$t('credit_score.best_offers')" :icon="icon"></InfoBox>
        </v-col>
    </v-row>

    <v-row v-bind:key="offer.id" v-for="(offer) in offers">
        <v-col cols="12">
            <Offer :offer="offer" is_clickable="true" color="#FDDD2E"></Offer>
        </v-col>
    </v-row>

    <!-- <v-card class="pa-md-4">
        <v-card-title class="headline" style="word-break: break-word;">
            {{$t('credit_score.header')}}
        </v-card-title>
        <v-card-text class="pl-md-10 pr-md-10 pb-0 hidden-xs-only">
            <v-row>
                <v-col cols="12" lg="7" md="12">
                    <p>
                            <span v-html="$t(`credit_score.status.${scoreStatus}`)"></span>
                    </p>
                    <p class="mt-8 caption">* {{$t('credit_score.own_model')}}</p>
                </v-col>
                <v-col cols="12" lg="4" md="12">
                    <div class="mt-n12">
                        <CreditScoreChart :score="user.credit_score" height="280px"></CreditScoreChart>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-text class="pl-md-10 pr-md-10 pb-0 hidden-sm-and-up">
            <v-row>
                <v-col cols="12">
                    <div class="mt-n12">
                        <CreditScoreChart height="240px" :score="user.credit_score"></CreditScoreChart>
                    </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                    <div class="mt-n3">
                        <div style="text-decoration: underline" class="text-center">
                            <span @click="scoreStatusHint()">
                                <b>{{(user.credit_score ? user.credit_score : 0) + ' ' +  $t('credit_score.points')}}</b> - {{$t('credit_score.score_status_hint')}}
                            </span>
                        </div>
                        <div v-if="scoreStatusIsOpened" class="mt-3">
                            <span v-html="$t(`credit_score.status.${scoreStatus}`)"></span>
                        </div>
                    </div>

                </v-col>
                <v-col cols="12">
                    <p class="mt-n4 caption">* {{$t('credit_score.own_model')}}</p>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="creditScoreQuestions()">
                {{user.credit_score ? $t('credit_score.change_answers') : $t('credit_score.get_rating')}}
            </v-btn>
        </v-card-actions>
        <div class="pa-4" v-if="user.credit_score">
            <div v-if="offers && offers.length">
                <div class="hidden-md-and-up">
                    <h3 class="font-weight-bold">{{$t('credit_score.best_offers')}}: </h3>
                </div>
                <div class="hidden-sm-and-down">
                    <h3 class="font-weight-bold mt-4 pb-2 offer-headline">{{$t('credit_score.best_offers')}}: </h3>
                </div>
                <OfferCards :offers="offers"></OfferCards>
            </div>
        </div>
    </v-card> -->
</div>
</template>

<script>
    import CreditScoreService from "../services/creditScoreService";
    import OfferCards from "../../../offers/shared/components/offerCards";
    import CreditScoreChart from '@/app/mobile/profile/shared/components/creditScoreChart';
    import Offer from "../../../offers/shared/components/offer";
    import InfoBox from "@/app/mobile/ui/InfoBox";
    import iconDollar from '@/assets/img/icon-dollar.png'

    export default {
        name: 'CreditScoreTemplate',
        components: {
            CreditScoreChart,
            OfferCards,
            Offer,
            InfoBox
        },
        data() {
            return {
                scoreStatusIsOpened: false,
                icon: iconDollar
            }
        },
        computed: {
            user() {
                return this.$store.getters.AUTH_USER;
            },
            scoreStatus() {
                return this.user
                    ? CreditScoreService.status(this.user.credit_score)
                    : 'very_low';
            },
            offers() {
                return this.$store.getters.CS_OFFERS;
            },
        },
        methods: {
            creditScoreQuestions() {
                this.$store.dispatch('OPEN_CREDIT_SCORE_MODAL', true)
            },
            scoreStatusHint() {
                this.scoreStatusIsOpened = !this.scoreStatusIsOpened;
            }
        }

    }
</script>

<style>
    .offer-headline {
        font-size: 20px !important;
    }
    .v-card__text, .v-card__title {
        word-break: normal;
    }
</style>
